import React from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import { motion } from "framer-motion";
import { AccessTime, Timeline, MonitorHeart, Security } from "@mui/icons-material";

const features = [
  {
    icon: <Timeline fontSize="large" color="primary" />,
    title: "Track Lab Results",
    description: "Easily input and review creatinine, eGFR, potassium, and more.",
  },
  {
    icon: <MonitorHeart fontSize="large" color="primary" />,
    title: "Visual Health Trends",
    description: "See your health over time with clean, interactive graphs.",
  },
  {
    icon: <AccessTime fontSize="large" color="primary" />,
    title: "Reminders & Alerts",
    description: "Never miss a check-up or catch a risky trend too late.",
  },
  {
    icon: <Security fontSize="large" color="primary" />,
    title: "Secure & Private",
    description: "Your data is safe with Firebase and encrypted connections.",
  },
];

export default function FeaturesSection() {
  return (
    <Box sx={{ py: 10, bgcolor: "#f9f9f9" }}>
      <Typography variant="h4" align="center" fontWeight="bold" gutterBottom>
        Features You'll Love
      </Typography>
      <Typography variant="body1" align="center" sx={{ mb: 6 }}>
        Designed to support your post-transplant journey with clarity and care.
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              viewport={{ once: true }}
            >
              <Card
                elevation={3}
                sx={{
                  p: 3,
                  textAlign: "center",
                  height: "100%",
                  borderRadius: 3,
                  backgroundColor: "white",
                }}
              >
                <Box mb={2}>{feature.icon}</Box>
                <CardContent>
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}